// TOAST MESSAGE
export const TOAST_NEW_STATE = "TOAST_NEW_STATE";

// CART and SAVE FOR LATER
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SAVE_FOR_LATER = "SAVE_FOR_LATER";
export const MOVE_TO_CART = "MOVE_TO_CART";
export const REMOVE_SAVE_FOR_LATER = "REMOVE_SAVE_FOR_LATER";
export const UPDATE_PRODUCT_COUNT = "UPDATE_PRODUCT_COUNT";
